import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/(generated)/diwali-delights-with-locobuzz/Body.jsx");
